exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-table[data-v-515cdd7b] {\n  margin-bottom: 20px;\n  position: relative;\n  z-index: 1;\n  display: inline-block;\n  width: 100%;\n}\n[data-v-515cdd7b] .el-table th {\n  padding: 2px 0;\n}\n[data-v-515cdd7b] .el-table th.el-table__cell {\n  overflow: hidden;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-color: #FFF;\n}\n[data-v-515cdd7b] .el-table__footer-wrapper tbody td.el-table__cell, .el-table__header-wrapper tbody td.el-table__cell[data-v-515cdd7b] {\n  font-weight: bold;\n  background-color: #F5F7FA;\n  color: #0957f4;\n}\n", ""]);

// exports
